import React from "react";
import Plan from "./Plan";
import Comment from "./Comment";
import Faq from "./Faq";
import Testimonials from "../../components/Testimonials";
import SEOHead from "../../components/SEOHead";
import { usePageSEO } from "../../utils/seoUtils";

const Pricing = () => {
    const seoData = usePageSEO('/forfaits');
    
    return (
        <>
            <SEOHead {...seoData} />
            <Plan />
            <Comment />
            <Faq />
            <Testimonials className="section-bg" />
        </>
    );
};

export default Pricing;
